import {Record} from 'immutable';
import {requiredMessage} from 'utils/const';
import User from 'records/User';

/**
 * Validate that a participant is selected.
 *
 * Note: this validation runs after choosing coach/recipient, so we check for the id
 * Calls/comments/scores will be selected in a later step, with defaults
 *
 * @param participant
 * @return optional list of errors to display
 */
export function validate(participant) {
  const errors = {};

  if (!participant.id) {
    errors['id'] = requiredMessage;
  }

  return errors;
}

export default class CoachingParticipant extends Record({
  id: undefined,
  prepNumberOfCalls: 0,
  prepShouldComment: false,
  prepShouldScore: false,
  info: undefined,
}) {
  readonly id: string;
  readonly prepNumberOfCalls: number;
  readonly prepShouldComment: boolean;
  readonly prepShouldScore: boolean;
  readonly info?: User;

  constructor(object: Partial<CoachingParticipant> = {}) {
    super({
      ...object,
      info: object.info ? new User(object.info as any) : undefined,
    });
  }
}
